class CardData {
    constructor(type, name,  age, id = null, version = undefined)
    {
        this.type = type;
        this.name = name;
        this.age = age;
        // Unique per physical card in a game; assigned by GameStateData so moves can reference cards.
        this.id = id;
        // A leader or wonder the expansion changed: 'expansion' for its expansion version (none: the base game's; see
        // Constants/CardVersions.js)
        if (version)
        {
            this.version = version;
        }
    }
}

module.exports = CardData;